import React from "react";

// // // //

// All regular fonts
// NOTE - we this list only includes the font weights that are being used
// NOTE - we only fetch TWK-Lausanna-400 to optimize performance
export const fontUrls = [
    // "https://cdn.rwa.xyz/fonts/woff/TWKLausanne-100.woff2",
    // "https://cdn.rwa.xyz/fonts/woff/TWKLausanne-300.woff2",
    "https://cdn.rwa.xyz/fonts/woff/TWKLausanne-400.woff2",
    // "https://cdn.rwa.xyz/fonts/woff/TWKLausanne-500.woff2",
    // "https://cdn.rwa.xyz/fonts/woff/TWKLausanne-600.woff2",
    // "https://cdn.rwa.xyz/fonts/woff/TWKLausanne-700.woff2",
];

/**
 * FontPreloader
 * Preloads font files in the app
 *
 */
export function FontPreloader() {
    return (
        <>
            {fontUrls.map((font) => {
                const ext = font.split(".").pop();
                const type = `font/${ext}`;
                return (
                    <link
                        key={font}
                        rel="preload"
                        href={font}
                        as="font"
                        type={type}
                        crossOrigin="anonymous"
                    />
                );
            })}
        </>
    );
}
